import React, { useState } from 'react';
import ChangeCourse from './change-course';
import ChangeLevel from './change-level';
import CompleteLevel from './complete-level';
import ChangeStudent from './change-student';
import { Tabs } from '../ui-pending';

type ChangeCourseTabKey = 'course' | 'level' | 'complete' | 'student';

// Change Course / Change Level / Course Transfer now live in the transaction-based
// "Course Change" menu; this screen only keeps Complete Level. The other tabs stay wired
// below so they can be re-enabled by adding them back here.
const TAB_ITEMS: { id: ChangeCourseTabKey; label: string }[] = [
  { id: 'complete', label: 'Complete Level' },
];

const ChangeCourseWithTabs: React.FC<any> = ({ studentId, profileData, courseData, studentUserId }) => {
  const [activeTab, setActiveTab] = useState<ChangeCourseTabKey>('complete');

  return (
    <div className="ds-stack">
      <Tabs
        items={TAB_ITEMS}
        value={activeTab}
        onChange={(id) => setActiveTab(id as ChangeCourseTabKey)}
        ariaLabel="Change course actions"
      />

      <div>
        {activeTab === 'course' && (
          <div role="tabpanel">
            <ChangeCourse
              studentUserId={studentUserId}
              studentId={studentId}
              profileData={profileData}
              ccourseData={courseData}
            />
          </div>
        )}
        {activeTab === 'level' && (
          <div role="tabpanel">
            <ChangeLevel
              studentUserId={studentUserId}
              studentId={studentId}
              profileData={profileData}
              courseData={courseData}
            />
          </div>
        )}
        {activeTab === 'complete' && (
          <div role="tabpanel">
            <CompleteLevel studentId={studentId} profileData={profileData} />
          </div>
        )}
        {activeTab === 'student' && (
          <div role="tabpanel">
            <ChangeStudent studentId={studentId} profileData={profileData} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ChangeCourseWithTabs;
